import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { ProductPriceSchedulingListComponent } from "./product-price-scheduling-list/product-price-scheduling-list.component";
import { ProductPriceSchedulingDetailComponent } from "./product-price-scheduling-detail/product-price-scheduling-detail.component";

const productPriceSchedulingRoutes: Routes = [
  {
    path: "",
    component: ProductPriceSchedulingListComponent,
  },
  {
    path: "new",
    component: ProductPriceSchedulingDetailComponent,
  },
  {
    path: ":token",
    component: ProductPriceSchedulingDetailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(productPriceSchedulingRoutes)],
  exports: [RouterModule],
})
export class ProductPriceSchedulingRoutingModule {}
